export default {
  computed: {
    item() {
      return this.$store.getters.MOBILE_CART_MENU;
    },
  },
  methods: {
    goToAlbum(album) {
      this.$store.dispatch('SET_MOBILE_CART_MENU', null);
      this.$router.push(
          this.i18nLink(`album/gallery/${this.getAlbumId(album)}`));
    },
    getAlbumId(album) {
      if (album.album_status === '2') {
        return `${album.album_hash}-${album.album_hash_password}`;
      }

      return album.album_id;
    },
  },
};
